import React, { useState, useEffect } from 'react'
import { Col, Container, Row } from "react-bootstrap";
import Sidebar from "../../Components/Sidebar";
import Header from "../../Components/Header";
import { gettokenlist, deleteToken, getuserdaily, getusermonthly, getusercustom, getcsvdata, PromoteNFT, deleteStatus, NFTsMaySent, NFTStatus, HideNFTs } from '../../actions/users';
import ReactDatatable from "@ashvin27/react-datatable";
import { toastAlert } from "../../lib/toastAlert";
import envConfig from "../../lib/config"
import moment from 'moment';
import Exportexcel from "../pdf/Excelexport"
import Exportpdf from "../pdf/Exportpdf"
import Exportcsv from "../pdf/Exportcsv"


const TokenList = () => {
  const [userdet, setUser] = useState();
  const [exportdata, setExportdata] = useState([])
  const [allcheck, setAllcheck] = useState(false);

  useEffect(() => {
    getTokenlist()
  }, [])

  const getTokenlist = async () => {
    var test = await gettokenlist();
    if (test.Success) {
      setUser(test.userValue);
      var ddd = test.userValue.map(({ _id, tokenOwnerDb, ...rest }) => {

        return rest
      })
      setExportdata(ddd)
    }
    else
      toastAlert('error', "Error on Server")
  }

  const handleChangemaysent = async (event) => {
    let { id, checked } = event.target;
    let handlemaychange = await NFTStatus({ email: id, maySentChecked: checked });
    if (handlemaychange.Success) {
      toastAlert("success", 'Selected');
      getTokenlist()
    }
    else {
      toastAlert("error", 'Error on Server');
    }
  }

  const ViewTokens = async (record) => {
    if (record.tokenOwnerDb && record.tokenOwnerDb.tokenID && record.tokenOwnerDb.tokenOwner)
      window.location.href = "/viewToken/" + record.tokenOwnerDb.tokenOwner + "/" + String(record.tokenOwnerDb.tokenID);
    else
      window.location.href = "/viewToken/" + record.tokenOwner + "/" + String(record.tokenID);
  }

  const Enlarge = (e) => {
    if (Number(e.target.naturalWidth) > 700 || Number(e.target.naturalHeight) > 700) {
      e.target.width = String(Number(e.target.naturalWidth) / 4)
      e.target.height = String(Number(e.target.naturalHeight) / 4)
    }
    else {
      e.target.width = String(Number(e.target.naturalWidth) / 2)
      e.target.height = String(Number(e.target.naturalHeight) / 2)
    }
  }
  const VEnlarge = (e) => {
    if (Number(e.target.videoWidth) > 700 || Number(e.target.videoHeight) > 700) {
      e.target.width = String(Number(e.target.videoWidth) / 4)
      e.target.height = String(Number(e.target.videoHeight) / 4)
    }
    else {
      e.target.width = String(Number(e.target.videoWidth) / 2)
      e.target.height = String(Number(e.target.videoHeight) / 2)
    }
  }
  const Reset = (e) => {
    e.target.width = "25"
    e.target.height = "25"
  }

  const columns = [
    {
      key: "action",
      text: "Action",
      className: "action",
      width: 100,
      align: "center",
      sortable: false,
      cell: record => {
        return (
          <div className='text-center'>
            {record && <input type="checkbox" name={record.tokenID} id={record.tokenOwnerDb.tokenID} onChange={(event) => { handleChangemaysent(event) }} checked={record.tokenOwnerDb.MayChecked == "true" || record.tokenOwnerDb.MayChecked == true ? true : false} />}
          </div>
        );
      }
    },
    {
      key: "sno",
      text: "SNo",
      className: "sno",
      align: "center",
      sortable: false,
      cell: (record, index) =>
        <p className="exchange_table_values text-center">{index + 1}</p>,
    },
    {
      key: "tokenCount",
      text: "Token Count",
      className: "tokenCount",
      align: "center",
      sortable: false,
      cell: (record, index) =>
        <p className="exchange_table_values text-center">{record?.tokenID}</p>,
    },
    {
      key: "NFTtokenPreview",
      text: "NFT Token Preview",
      className: "NFTtokenPreview",
      align: "center",
      sortable: false,
      cell: (record, index) =>
        <div className="exchange_table_values text-center">
          {record.image &&
            (record.image.split(".").pop() !== "mp4") ? (
            <img
              width="25"
              height="25"
              src={`${envConfig.Back_Url}/nftImg/${record.tokenCreator}/${record.image}`}
            />
          )
            :
            (
              <video
                width="25"
                height="25"
                autoPlay
                muted
                loop
                type="video/mp4"
                src={`${envConfig.Back_Url}/imfImg/${record.tokenCreator}/${record.additionalImage}`}
              />
            )}
        </div>
    },
    {
      key: "tokenName",
      text: "Token Name",
      className: "tokenName",
      align: "center",
      sortable: false,
      cell: (record, index) =>
        <p className="exchange_table_values text-center">{record?.tokenName}</p>,
    },
    {
      key: "tokenCreator",
      text: "Token Creator",
      className: "tokenCreator",
      align: "center",
      sortable: false,
      cell: (record, index) =>
        <p className="exchange_table_values text-center">{record?.tokenCreator}</p>,
    },
    {
      key: "tokenOwner",
      text: "Token Owner",
      className: "tokenOwner",
      align: "center",
      sortable: false,
      cell: (record, index) =>
        <p className="exchange_table_values text-center">{record?.tokenOwner}</p>,
    },
    {
      key: "tokenCategory",
      text: "Token Category",
      className: "tokenCategory",
      align: "center",
      sortable: false,
      cell: (record, index) =>
        <p className="exchange_table_values text-center">{record?.tokenCategory}</p>
    },
    {
      key: "tokenRoyality",
      text: "Token Royality(in percentage)",
      className: "tokenRoyality",
      align: "center",
      sortable: false,
      cell: (record, index) =>
        <p className="exchange_table_values text-center">{record?.tokenRoyality}</p>
    },
    {
      key: "tokenBid",
      text: "Token Bid",
      className: "tokenBid",
      align: "center",
      sortable: false,
      cell: val =>
        <p className="exchange_table_values text-center">{(val.tokenBid).toString()}</p>

    },
    {
      key: "tokenQuantity",
      text: "Token Quantity",
      className: "tokenQuantity",
      align: "center",
      sortable: false,
      cell: (record, index) =>
        <p className="exchange_table_values text-center">{record?.tokenQuantity}</p>
    },
    {

      key: "balance",
      text: "Token Available Quantity(balance)",
      className: "balance",
      align: "center",
      sortable: false,
      cell: val =>
        <p className="exchange_table_values text-center">{String(val.tokenOwnerDb.balance)}</p>
    },

    {

      key: "tokenPrice",
      text: "Token Price",
      className: "tokenPrice",
      align: "center",
      sortable: false,
      cell: val => <>
        {val.tokenOwnerDb.tokenPrice &&
          <div><p className="exchange_table_values text-center">{String(val.tokenOwnerDb.tokenPrice)} {String(val.tokenOwnerDb.coinname)}</p></div>
        }
      </>
    },
    {

      key: "auctionstart",
      text: "Auction Start Time",
      className: "tokenPrice",
      align: "center",
      sortable: false,
      cell: record =>
        <div><p className="exchange_table_values text-center">{record.auctionstart != null ? moment(record.auctionstart).format('MMMM,Do YYYY, hh:mm A') : "null"}</p></div>


    },
    {

      key: "auctionend",
      text: "Auction End Time",
      className: "tokenPrice",
      align: "center",
      sortable: false,
      cell: record =>
        <div><p className="exchange_table_values text-center">{record.auctionend != null ? moment(record.auctionend).format('MMMM,Do YYYY, hh:mm A') : "null"}</p></div>

    },
    {

      key: "minimumBid",
      text: "Minimum Bid For Timed Auction",
      className: "minimumBid",
      align: "center",
      sortable: false,
      cell: record =>
        <div><p className="exchange_table_values text-center">{record.minimumBid} {record.coinname}</p></div>


    },
    {

      key: "status",
      text: "Token Status",
      className: "status",
      align: "center",
      sortable: false

    },
    {

      key: "ipfsimage",
      text: "Image Hash Value",
      className: "image",
      align: "center",
      sortable: false,
      cell: record =>
        <div><p className="exchange_table_values text-center">{(record.status)}</p></div>


    },
    {
      key: "timestamp",
      text: "Created At",
      className: "Date",
      align: "center",
      sortable: false,
      cell: record =>
        <div><p className="exchange_table_values text-center">{moment(record.timestamp).format('MMMM,Do YYYY, hh:mm A')}</p></div>
    },
    {
      key: "deleted",
      text: "Hide/Show",
      className: "Date",
      align: "center",
      sortable: false,
      cell: record =>
        <div><p className="exchange_table_values text-center">{(record.tokenOwnerDb.deleted == 1) ? "Visible" : "Hidden"}</p></div>
    },
    {
      key: "action",
      text: "View Token",
      className: "action",
      width: 100,
      align: "center",
      sortable: false,
      cell: record => {
        return (
          <div className='text-center'>
            <button
              data-toggle="modal"
              data-target="#update-template-modal"
              className="btn btn-primary btn-sm"
              onClick={() => ViewTokens(record)}

              style={{ marginRight: '5px' }}
            >
              <i className="fa fa-eye"></i>
            </button>
          </div>
        );
      }
    },
  ];

  const config = {
    page_size: 5,
    length_menu: [10, 20, 50],
    filename: "Users",
    no_data_text: "No user found!",

    language: {
      length_menu: "Show _MENU_ result per page",
      filter: "Filter in records...",
      info: "Showing _START_ to _END_ of _TOTAL_ records",
      pagination: {
        first: "First",
        previous: <> Previous </>,
        next: <>Next</>,
        last: "Last",
      },
    },
    show_length_menu: true,
    show_filter: true,
    show_pagination: true,
    show_info: true,
    defaultSortAsc: true,
  };

  const setMaySent = async (data) => {
    if (data?.target) {
      if (userdet.length > 0) {

        var resp = await NFTsMaySent({ all: data.target.checked });
        if (resp?.Success) {
          setAllcheck(!allcheck)
          toastAlert('success', 'Success...Please wait for data refresh');
          getTokenlist()
        }
        else
          toastAlert("error", resp.Message)
      } else {
        toastAlert("error", "Subscribers are not yet")
      }
    } else {
      var payload = {
        email: data.email,
        maySent: !data.maySent
      }

      var resp = await NFTsMaySent(payload);
      if (resp?.Success) {
        toastAlert("success", 'Success...Please wait for data refresh');
        getTokenlist()
      }
      else
        toastAlert("error", resp.msg)
    }

  }

  const deleteUser = async () => {
    var send = {
      Show: "Hide"
    }
    let handlemaychange = await HideNFTs(send);
    if (handlemaychange.Success) {
      toastAlert('success', 'Collection Hide Succesfully');
      getTokenlist()
    }
    else {
      toastAlert('error', 'Error on Server');
    }
  }

  const Show = async () => {
    var send = {
      Show: "Show"
    }
    let handlemaychange = await HideNFTs(send);
    if (handlemaychange.Success) {
      toastAlert('success', 'Collection is Visible Now');
      getTokenlist()
    }
    else {
      toastAlert('error', 'Error on Server');
    }
  }

  return (
    <>
      <Container fluid className="common_bg position-relative">
        <div className="liner"></div>
        <Row>
          <Col xl={2} lg={0} className='p-0 d-none d-xl-block'>
            <Sidebar />
          </Col>
          <Col xl={10} lg={12}>
            <Header title={'Token List'} />

            <div className="common_page_scroller mt-5 pe-2">
              <div className="page_header">
                <h3 className='text-white'>Token List</h3>
                <div>
                  <div className="selection_sec">
                    <div className="checkbox_sec_user">
                      <span>SELECT ALL</span>
                      <input type="checkbox" className='selectall ms-2' checked={allcheck} onChange={(e) => setMaySent(e)} />
                    </div>
                    <div>
                      <button className="ms-3" variant="contained" onClick={() => deleteUser()} color="primary">Hide NFTS</button>
                    </div>
                    <div>
                      <button className="ms-3" variant="contained" onClick={() => Show()} color="primary">Show NFTS</button>
                    </div>
                  </div>

                </div>
              </div>
              <div className="exchange_table_holder dashboard_box rounded-3 mt-4">
                <ReactDatatable
                  config={config}
                  records={userdet}
                  columns={columns}
                />
              </div>
              <div className='bottom_btn_comp'>
              <Exportexcel excelData={exportdata} fileName={'Token List'} />
              <Exportpdf pdfData={exportdata} fileName={'Token List'} />
              <Exportcsv csvData={exportdata} fileName={'Token List'} />
            </div>
            </div>
          
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default TokenList